import { apiSlice } from "./apiSlice";



export const portfolioSummarySlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {
            getPortfolioSummary: builder.query({
                query: () => ({
                    url: "Project/portfolio-summary"
                })
            })
        }
    }
})


export const { useGetPortfolioSummaryQuery } = portfolioSummarySlice